/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./src/assets/js/carrers-section.js ***!
  \******************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CarrersSection = /*#__PURE__*/function () {
  function CarrersSection() {
    _classCallCheck(this, CarrersSection);

    this.selectors = {
      section: ".carrers-section",
      sidebar: ".carrers-sidebar",
      post: ".carres-posts__cards",
      sidebarLink: ".carrers-sidebar__list__item"
    };
    this.modificators = {
      active: "active"
    };
    this.activeScroll = false;
  }

  _createClass(CarrersSection, [{
    key: "onChangeActivePosts",
    value: function onChangeActivePosts(event, section) {
      event.preventDefault();
      var newActiveLink = event.currentTarget;
      var activeLink = section.querySelector("".concat(this.selectors.sidebarLink, ".").concat(this.modificators.active));
      var activeId = newActiveLink.getAttribute('data-index');
      activeLink.classList.remove(this.modificators.active);
      newActiveLink.classList.add(this.modificators.active);
      var newActivePosts = section.querySelector("".concat(this.selectors.post, "[data-index=\"").concat(activeId, "\"]"));
      var currentActivePost = section.querySelector("".concat(this.selectors.post, ".").concat(this.modificators.active));
      currentActivePost.classList.remove(this.modificators.active);
      newActivePosts.classList.add(this.modificators.active);
    }
  }, {
    key: "initListeners",
    value: function initListeners(section) {
      var _this = this;

      var sidebarLinks = section.querySelectorAll(this.selectors.sidebarLink);
      if (!sidebarLinks.length) return;
      sidebarLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          _this.onChangeActivePosts(event, section);
        });
      });
    }
  }, {
    key: "handleSections",
    value: function handleSections() {
      var _this2 = this;

      var sections = document.querySelectorAll(this.selectors.section);
      if (!sections.length) return;
      sections.forEach(function (section) {
        _this2.initListeners(section);
      });
    }
  }]);

  return CarrersSection;
}();

document.addEventListener("DOMContentLoaded", function () {
  var carrersSection = new CarrersSection();
  carrersSection.handleSections();
  window.CarrersSection = carrersSection;
});
/******/ })()
;